import React from 'react'
import { Grid, InputLabel, MenuItem } from '@material-ui/core'
import { SelectPlaceholder } from 'asterX-UI/Inputs'
import { useStyles } from '../../../pages/ContractPage/components/AddEvents/add-events.styles'

const WriteOffSection = ({ writeOff, onPathChange, IconComponent, reasons, errors = {} }) => {
  const classes = useStyles()

  return (
    <>
      <Grid item xs={12} className={classes.item}>
        <InputLabel shrink className={classes.inputLabel}>
          Причина списания *
        </InputLabel>
        <SelectPlaceholder
          IconComponent={IconComponent}
          name="writeOff.reason"
          value={writeOff.reason}
          onChange={onPathChange}
          fullWidth
          placeholder="Не выбрано"
          error={Boolean(errors['writeOff.reason'])}
        >
          <MenuItem value={''}>Не выбрано</MenuItem>
          {reasons.map(r => (
            <MenuItem key={r} value={r}>
              {r}
            </MenuItem>
          ))}
        </SelectPlaceholder>
      </Grid>
    </>
  )
}

export default WriteOffSection
